module.exports = __webpack_public_path__ + "2db379b318796c27210821fb8ea88012.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-condensed-italic-webfont.eot
// module id = 440
// module chunks = 0